export default "__VITE_ASSET__b844fb48__"